/** The NexBasira wordmark — same treatment as the marketing site's
 * `.nb-logo` (font-display, bold, tracking, mint accents with glow). Used
 * on the auth pages (login / signup / forgot / reset). */
export function BrandLogo({ className = "" }: { className?: string }) {
  const glow = { textShadow: "0 0 10px var(--nb-mint-glow)" } as const;
  return (
    <div
      className={`font-display text-2xl font-bold tracking-tight text-nb-text ${className}`}
      style={{ letterSpacing: "-1px" }}
    >
      Nex
      <span className="text-nb-mint" style={glow}>
        .
      </span>
      Basira
      <span className="text-nb-mint" style={glow}>
        /
      </span>
    </div>
  );
}
